module.exports = __webpack_public_path__ + "img/ECGSUCTIONKIT.319df3e6.jpg";